"use client";

import { CookiesProvider as ReactCookieProvider } from "react-cookie";
import React from "react";
import dynamic from "next/dynamic";

const CookieAgreement = dynamic(
  () => import("components/site/CookieAgreement"),
  {
    ssr: false
  }
);

interface Props {
  children: React.ReactNode;
}

export const ClientCookieProvider: React.FC<Props> = ({ children }) => (
  <ReactCookieProvider>
    <CookieAgreement />
    {children}
  </ReactCookieProvider>
);
